import Component from 'D:/AUTOMFL/UniApp/uniAdmin/windows/topWindow.vue'
wx.createComponent(Component)